import { render, staticRenderFns } from "./expressList.vue?vue&type=template&id=513190b2"
import script from "./expressList.vue?vue&type=script&lang=js"
export * from "./expressList.vue?vue&type=script&lang=js"
import style0 from "./expressList.vue?vue&type=style&index=0&id=513190b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports